import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UntilDestroy } from "@ngneat/until-destroy";
import { Observable } from "rxjs";
import { AccountService } from "@modules/account/services/account.service";
import { Fiat } from "@models";
import { StakingBannerFacade } from "@modules/staking/domain/+state/staking-banner.facade";
import { StakingBannerState } from "@modules/staking/domain/entities/staking-banner-state.model";
import { PortfolioFacade } from "@modules/portfolio/domain/portfolio.facade";
import { AutoStakingTrackingFacade } from "@modules/staking/domain/+state/auto-staking-tracking.facade";

@UntilDestroy()
@Component({
	selector: "staking-widget",
	templateUrl: "./staking-widget.component.html",
	styleUrls: ["./staking-widget.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class StakingWidgetComponent implements OnInit {
	public state$: Observable<StakingBannerState> = this.stakingBannerFacade.getBannerStateData$();
	public isHideValueActive$: Observable<boolean> = this.portfolioFacade.isPortfolioDataHidden$;
	public defaultFiat: Fiat = null;

	public constructor(
		private readonly router: Router,
		private readonly accountService: AccountService,
		private readonly stakingBannerFacade: StakingBannerFacade,
		private readonly portfolioFacade: PortfolioFacade,
		private readonly autoStakingTrackingFacade: AutoStakingTrackingFacade
	) {}

	public ngOnInit(): void {
		this.defaultFiat = this.accountService.getDefaultFiat();
	}

	public onButtonClick(state: StakingBannerState): void {
		if (state.hasError) {
			this.stakingBannerFacade.fetchBannerData();
		} else {
			this.goToRoute(state.stakedCoins === 0);
		}
	}

	public goToRoute(startStaking: boolean): void {
		if (startStaking) {
			this.router.navigate(["", { outlets: { modal: "stake" } }], {
				skipLocationChange: true
			});
		} else {
			this.autoStakingTrackingFacade.updateFlowStarted("home");
			this.router.navigate(["/my-account/staking-overview"]);
		}
	}
}
